module.exports = __webpack_public_path__ + "media/1.7ee6ed2d.wav";